import { $t } from '@/utils/languageAuto';
import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import errorPage from './component/error.vue';

var ErrorTipPage = function (_super) {
  __extends(ErrorTipPage, _super);

  function ErrorTipPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.errorData = {
      text: $t("\u60A8\u6240\u8BBF\u95EE\u7684\u9875\u9762\u4E0D\u5B58\u5728"),
      content: $t("\u60A8\u53EF\u4EE5"),
      url: '/',
      linkText: $t("\u8FD4\u56DE\u9996\u9875"),
      id: '404_to_home'
    };
    return _this;
  }

  ErrorTipPage = __decorate([Component({
    components: {
      errorPage: errorPage
    }
  })], ErrorTipPage);
  return ErrorTipPage;
}(Vue);

export default ErrorTipPage;